import { apiClient } from './api-client';

export interface Manufacturer {
  id: string;
  tenantId: string;
  name: string;
  description: string | null;
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ManufacturerListResponse {
  items: Manufacturer[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateManufacturerPayload {
  name: string;
  description?: string;
}
export type UpdateManufacturerPayload = Partial<CreateManufacturerPayload> & { isActive?: boolean };

export const manufacturerService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<ManufacturerListResponse> =>
    apiClient.get<ManufacturerListResponse>('/manufacturers', { params }).then((r) => r.data),

  create: (payload: CreateManufacturerPayload): Promise<Manufacturer> =>
    apiClient.post<Manufacturer>('/manufacturers', payload).then((r) => r.data),

  update: (id: string, payload: UpdateManufacturerPayload): Promise<Manufacturer> =>
    apiClient.patch<Manufacturer>(`/manufacturers/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/manufacturers/${id}`).then(() => undefined),
};
